import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router"
import {routes} from "./routes"
import 'animate.css'
import i18n from '/src/plugins/i18n'
import VueMeta from "vue-meta"
import './styles/tailwind.css'
const Particles = require("particles.vue").default

Vue.use(VueRouter)
Vue.use(VueMeta)
Vue.use(Particles);

const router = new VueRouter({
  routes,
  mode: "history",
})



Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  i18n,
  router,
}).$mount('#app')